import React from 'react';
import DocsContent from '../components/DocsContent';

function Docs() {
  return (
    <div className="bg-white overflow-hidden shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <DocsContent />
      </div>
    </div>
  );
}

export default Docs;
